import React, { useContext, useEffect, useState } from 'react';
import FlexColumn from '../components/shared/FlexColumn';
import FlexRow from '../components/shared/FlexRow';
import UserContext from '../context/UserContext';
import { apiConfig, DISTRIBUTION_URL } from '../utils/apiConfig';
import { API } from '../utils/API';

export default function IAM({ token }) {
  const { role } = useContext(UserContext);
  const isAdmin = role === 'admin';
  const [uploading, setUploading] = useState(false);
  const [IAMBody, setIAMBody] = useState({
    image: '',
    link: '',
    active: false,
  });

  const [saving, setSaving] = useState(false);

  const uploadFile = async (file) => {
    try {
      const imageCreationTime = new Date().getTime();
      const fileNameCover = `${imageCreationTime}_iamImage.jpg`;

      const presignedUrlResponse = await fetch(`${apiConfig.media.uploadImage}/iamImage/${fileNameCover}/jpeg`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!presignedUrlResponse.ok) {
        throw new Error(`Failed to get pre-signed URL: ${presignedUrlResponse.statusText}`);
      }

      const presignedUrl = await presignedUrlResponse.text();
      const response = await fetch(presignedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'image/jpeg',
        },
        body: file,
      });

      if (!response.ok) {
        throw new Error(`File upload failed: ${response.statusText}`);
      }

      const CoverImage = `iamImage/${fileNameCover}`;
      console.log('[uploadFile] Cover image uploaded successfully!');
      return CoverImage;
    } catch (e) {
      console.error('[IAM] [UploadFile] Error:', e);
      return '';
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const uploadedUrl = await uploadFile(file);
    setIAMBody((prev) => ({ ...prev, image: uploadedUrl }));
    setUploading(false);
  };

  const fetchIamConfig = async () => {
    const res = await API(apiConfig.forumSettings.getIAM);
    if (res.status) {
      setIAMBody(res.iamDoc);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    const body = {
      image: IAMBody.image,
      link: IAMBody.link,
      active: IAMBody.active,
    };
    const res = await API(apiConfig.forumSettings.updateIAMConfig, 'POST', body);

    if (res.status) {
      alert('Saved successfully!');
    } else {
      alert('Failed to save.');
    }

    setSaving(false);
  };

  useEffect(() => {
    fetchIamConfig();
  }, []);

  return (
    <FlexColumn expand={styles.container}>
      <h2 style={styles.heading}>הודעה קופצת בתוך האפליקציה</h2>

      <FlexRow style={styles.uploadRow}>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        {uploading && <p style={{ margin: 0 }}>מעלה תמונה...</p>}
      </FlexRow>

      {IAMBody.image && (
        <img src={`${DISTRIBUTION_URL}${IAMBody.image}`} alt="Uploaded preview" style={styles.imagePreview} />
      )}
      <p style={styles.dimensions}>רוחב - 361px | גובה - 656px</p>

      <div style={styles.form}>
        <label style={styles.label}>לינק:</label>
        <input
          type="text"
          value={IAMBody.link}
          onChange={(e) => setIAMBody((prev) => ({ ...prev, link: e.target.value }))}
          style={styles.input}
          placeholder="https://example.com"
        />

        <label style={styles.checkboxLabel}>
          <input
            type="checkbox"
            checked={IAMBody.active}
            onChange={(e) => setIAMBody((prev) => ({ ...prev, active: e.target.checked }))}
          />
          <span style={{ marginInlineStart: 8 }}>פעיל</span>
        </label>

        {isAdmin && (
          <button style={styles.saveButton} onClick={handleSave} disabled={saving}>
            {saving ? 'שומר...' : 'שמירה'}
          </button>
        )}
      </div>
    </FlexColumn>
  );
}

const styles = {
  container: {
    padding: 30,
    paddingBottom: 150,
    maxWidth: 600,
    margin: 'auto',
    fontFamily: 'sans-serif',
  },
  card: {
    padding: 20,
    border: '1px solid #ccc',
    borderRadius: 12,
    backgroundColor: '#fafafa',
    marginBottom: 40,
    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
  },
  heading: {
    marginBottom: 16,
    fontSize: 22,
    fontWeight: 600,
  },
  uploadRow: {
    alignItems: 'center',
    gap: 16,
    marginBottom: 16,
  },
  imagePreview: {
    width: 200,
    borderRadius: 10,
    marginTop: 10,
    boxShadow: '0 0 8px rgba(0,0,0,0.1)',
  },
  dimensions: {
    fontSize: 14,
    color: '#666',
    marginTop: 8,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  label: {
    fontSize: 16,
    fontWeight: 500,
  },
  input: {
    padding: 10,
    fontSize: 15,
    border: '1px solid #ccc',
    borderRadius: 4,
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 15,
  },
  saveButton: {
    backgroundColor: '#8f3cc0',
    color: '#fff',
    padding: '12px 20px',
    borderRadius: 24,
    border: 'none',
    fontWeight: 600,
    fontSize: 16,
    cursor: 'pointer',
    marginTop: 20,
  },
};
